import React from "react";
import {GeneralUtilsAction} from "../../../../actions";
import {connect} from "react-redux";
import {WARNING_SINGLE_BUTTON_TEXT} from "../../../../constants/otherTexts";
import {Confirm} from "../../../../components/confirm";

const Index = ({status, data, closeModal}) => {
  return (
    <Confirm
      show={status}
      rejectHandler={() => closeModal()}
      close={() => closeModal()}
      content={{
        type: "danger",
        title: data.title,
        message: data.message,
        rejectButtonText: WARNING_SINGLE_BUTTON_TEXT
      }}
    />
  );
};

const mapStateToProps = store => {
  return {
    status: store.GeneralUtils.modalStatusForLongError,
    data: store.GeneralUtils.modalDataForLongError,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    closeModal: () => {
      dispatch(GeneralUtilsAction.closeModalForLongError());
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);
